import React, { Component } from "react";

export default class DisplayByPermission extends Component {
  render() {
    const { display, children } = this.props;
    return (display && <React.Fragment>{children}</React.Fragment>) || null;
  }
}
